<template>
  <div class="flex h-screen justify-center overflow-y-auto py-10 md:py-16">
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSeDHfxh1ui7lMHMQYu6V8Z2IpCP4SNfXegGH4x6xrj7GMG7_Q/viewform?embedded=true"
      width="640"
      height="100%"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
      class="grow"
    >Loading…
    </iframe>
  </div>
</template>
